import {forwardRef} from "react";
import {useGetCurrentWorkspaceId} from "@tinct/core-workspace";
import {LayoutHeader} from "@tinct/web-layout";
import {UpdateValueAndMessagingForm} from "../../../forms/update-value-and-messaging-form";
import {useFunnel} from "@tinct/web-funnel";

export const Step4ValueMessaging = forwardRef<HTMLFormElement, object>((_, ref) => {
  const workspaceId = useGetCurrentWorkspaceId();
  const { navigateToNextStep } = useFunnel();

  return (
    <div className="container max-w-4xl mx-auto gap-8 flex flex-col py-8">
      <LayoutHeader
        pageTitle="Brand Guidelines"
        pageDescription="Value & Messaging"
      />
      <UpdateValueAndMessagingForm ref={ref} organizationId={workspaceId} onSuccess={navigateToNextStep} hideFooter />
    </div>
  );
});

Step4ValueMessaging.displayName = 'Step4ValueMessaging';
